<img src="/assets/find-file.svg" alt="Page not found" />
<h4>Page Not Found</h4>
<div>The page you are looking for does not exist or has been moved.</div>
<div>
  Return to the
  <a [routerLink]="['']" aria-label="Return to the homepage"
    >{{ siteName }} homepage</a
  >.
</div>
